/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type CreateTemplateInput } from '@therapy/shared-validators';

import { apiClient } from './client.js';

export type { CreateTemplateInput };

export interface TemplateSummary {
  readonly id: string;
  readonly name: string;
  readonly programType: string | null;
  readonly description: string | null;
  readonly goalCount: number;
}

export interface TemplateGoal {
  readonly id: string;
  readonly title: string;
  readonly category: string | null;
  readonly measurementMethod: string | null;
  readonly baseline: string | null;
  readonly target: string | null;
  readonly approachTags: readonly string[];
  readonly steps: readonly string[];
  readonly sortOrder: number;
}

export interface TemplateDetail {
  readonly id: string;
  readonly name: string;
  readonly programType: string | null;
  readonly description: string | null;
  readonly goals: readonly TemplateGoal[];
}

export const templatesApi = {
  async list(): Promise<readonly TemplateSummary[]> {
    const { data } = await apiClient.get<readonly TemplateSummary[]>('/itp-templates');
    return data;
  },
  async getOne(id: string): Promise<TemplateDetail> {
    const { data } = await apiClient.get<TemplateDetail>(`/itp-templates/${id}`);
    return data;
  },
  async create(payload: CreateTemplateInput): Promise<TemplateDetail> {
    const { data } = await apiClient.post<TemplateDetail>('/itp-templates', payload);
    return data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/itp-templates/${id}`);
  },
};
